import useTranslation from 'next-translate/useTranslation';
import { NotificationOutline } from '@eqi-investimentos/icons/web';
import { Button, Text } from '@eqi-investimentos/react';
import { useNotifications } from '@/hooks/useNotifications';
import { Drawer } from '@/components/molecules/Drawer';
import { NotificationView } from '@/views/NotificationView/NotificationView';
import { IfRender } from '@/utils/jsx';
export const NotificationsButton = () => {
  const {
    t
  } = useTranslation('common');
  const {
    notifications,
    notificationsQuantity
  } = useNotifications();
  if (!notifications) return null;
  return <Drawer id="notification-modal" showIconButton={false} closeButtonProps={{
    top: '5xl',
    right: '2xl'
  }} backButtonProps={{
    buttonProps: {
      top: '3xl',
      left: '2xl'
    }
  }} contentProps={{
    bgColor: 'background.primary'
  }} headerProps={{
    px: '4.5rem',
    py: '3xl'
  }} bodyProps={{
    px: '2xl'
  }} headerContent={<Text size="2xl">{t('attributes.notifications')}</Text>} showCustomButton customButton={<Button position="relative" variant="naked" aria-label="button-open-notifications-drawer">
          <IfRender condition={notificationsQuantity > 0}>
            <Text position="absolute" top={0} right={0} w="1rem" h="1rem" size="label.s" lineHeight="1rem" bg="alert.information" color="content.alwaysLight" rounded="full">
              {notificationsQuantity}
            </Text>
          </IfRender>
          <NotificationOutline color="content.primary" boxSize="1.75rem !important" />
        </Button>} data-sentry-element="Drawer" data-sentry-component="NotificationsButton" data-sentry-source-file="NotificationsButton.tsx">
      <NotificationView notifications={notifications} data-sentry-element="NotificationView" data-sentry-source-file="NotificationsButton.tsx" />
    </Drawer>;
};